import { cn } from '@/lib/utils'

interface TagProps {
  children: React.ReactNode
  className?: string
}

export const Tag: React.FC<TagProps> = ({ children, className = '' }) => {
  return (
    <div
      className={cn(
        'h-5 rounded-md border border-border px-2.5',
        'flex items-center justify-center',
        'whitespace-nowrap text-xs font-semibold',
        className
      )}
    >
      {children}
    </div>
  )
}
